import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'

// Регистрация Service Worker
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(console.error)
}

// Restore accent color from localStorage
const savedAccent = localStorage.getItem('accent')
if (savedAccent) document.documentElement.style.setProperty('--accent', savedAccent)

// Restore font size from localStorage
const savedSize = localStorage.getItem('font-size')
if (savedSize) document.documentElement.style.setProperty('--font-size-base', `${savedSize}px`)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
